import { Outlet } from "react-router-dom";

const CommunitiesPage = () => {
  return <Outlet />;
};

export default CommunitiesPage;
